import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { Scene } from 'src/app/models/Scene';
import { FontService } from 'src/app/services/font.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-step-quiz-confirmation',
  templateUrl: './step-quiz-confirmation.component.html',
  styleUrls: ['./step-quiz-confirmation.component.scss'],
})
export class StepQuizConfirmationComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public fontFamilyOptions: any[];
  public fontSizeOptions: number[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };
  public selectOptions = {
    cssClass: 'quizard-select'
  };

  constructor(
    public fontService: FontService,
    public validationService: ValidationService
  ) {
    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
    this.fontSizeOptions = this.fontService.fontSizeOptions;
  }

  ngOnInit() { }

  getQuestionSetAsset(): QuestionSetAsset {
    return this.assetInScene.baseAsset as QuestionSetAsset;
  }

  setQuestionSetConfirmationTitleSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.endPageTitleSize = parseFloat(value.toFixed(1));

  }

  validateConfirmationTitleColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.endPageTitleColour.trim().length == 0) {
      questionSetAsset.endPageTitleColour = "#000000";
    }
  }

  setQuestionSetConfirmationTextSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.endPageTextSize = parseFloat(value.toFixed(1));

  }

  validateConfirmationTextColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.endPageTextColour.trim().length == 0) {
      questionSetAsset.endPageTextColour = "#000000";
    }
  }

  validateCompletedText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.confirmationPageAnswersCompletedText = questionSetAsset.confirmationPageAnswersCompletedText ? questionSetAsset.confirmationPageAnswersCompletedText : "";
    questionSetAsset.confirmationPageAnswersCompletedText = this.validationService.removeExcessLineBreaks(questionSetAsset.confirmationPageAnswersCompletedText);
  }

  validateNotCompletedText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.confirmationPageAnswersNotCompletedText = questionSetAsset.confirmationPageAnswersNotCompletedText ? questionSetAsset.confirmationPageAnswersNotCompletedText : "";
    questionSetAsset.confirmationPageAnswersNotCompletedText = this.validationService.removeExcessLineBreaks(questionSetAsset.confirmationPageAnswersNotCompletedText);
  }

}
